import type { FeaturedArticlesProps } from './featured-articles.d';

import React from 'react';
import { FeaturedArticles } from '/react4xp/parts/featuredArticles/FeaturedArticles';


export default function (props: FeaturedArticlesProps): React.JSX.Element {
	return <FeaturedArticles {...props} />;
}
